<template>
    <basic-container>
        <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="结算单审批" name="settle">
      <approve v-if="tabRefresh.settle"></approve>
    </el-tab-pane>
    <el-tab-pane label="支付单审批" name="pay">
      <approvalPayOrder2 v-if="tabRefresh.pay"></approvalPayOrder2>
    </el-tab-pane>
  </el-tabs>
    </basic-container>
 
</template>

<script>
import approve from "./approve.vue";
import approvalPayOrder2 from "@/views/chain/approvalPayOrder2/index.vue";
export default {
  data() {
    return {
        activeName:"settle",
      tabRefresh: {
        settle: true,
        pay: false,
      },
    };
  },
  components: {
    approve,
    approvalPayOrder2,
  },
  methods: {
    handleClick() {
      switch (this.activeName) {
        case "settle":
          this.switchTab("settle");
          break;
        case "pay":
          this.switchTab("pay");
          break;
        default:
          alert("默认，选择出错");
          console.log("wrong choice");
      }
    },
    switchTab(tab) {
      for (let [key, value] of Object.entries(this.tabRefresh)) {
        if (key == tab) {
          this.tabRefresh[key] = true;
        } else {
          this.tabRefresh[key] = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav-wrap::after{
    height: 0!important;

}
</style>